<script>
import buttonPhone from '@/components/button-phone.vue'
export default {
  name: 'career-counselor',
  components: { buttonPhone },
  data: () => ({}),
  computed: {},
  methods: {},
  created() {},
}
</script>

<template>
  <v-container class="d-flex flex-column align-center mb-12">
    <h1 class="text-h2 text-center primary--text font-weight-bold">
      Career Counselor
    </h1>

    <v-card max-width="800px" width="100%" class="rounded-lg mt-12">
      <v-card-text class="primary--text">
        <img
          height="200px"
          width="300px"
          src="https://media.eipl.org/site/images/services/career-counselor.jpg"
          class="d-block my-4 rounded mx-auto"
        />
        <p class="text-body-1 primary--text font-weight-black my-8">
          A trained Career Counselor is available by appointment for a
          one-on-one interview with any adult resident of the East Islip Library
          District.
        </p>
        <p
          class="text-body-1 primary--text text--lighten-2 font-weight-bold mb-4"
        >
          You will be able to receive help with writing a resume and cover
          letter, preparing for a job interview, exploring career changes and
          more.
        </p>
        <p class="primary-text mb-0 mt-10">
          Call the reference desk to make an appointment (581-9200 x 5)
        </p>
        <button-phone class="mt-4" />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<style scoped></style>
